import { ReactNode } from 'react';
import { TextColorType } from '../../shared/types/textColor.types';
import { StyleSheetColorType } from '../../shared/types/styleSheetColors.types';

const AppearsFromValues = {
  Top: 'top',
  Below: 'below',
  Left: 'left',
  Right: 'right',
} as const;

type AppearsFromType = typeof AppearsFromValues[keyof typeof AppearsFromValues];

interface ToolTipProps {
  appearsFrom?: AppearsFromType;
  text?: string | JSX.Element;
  color?: TextColorType;
  fillColor?: StyleSheetColorType;
  className?: string;
  children?: string | ReactNode;
}

export { ToolTipProps, AppearsFromValues, AppearsFromType };
